module.exports = __webpack_public_path__ + "static/dogs-barking-ca262bc14e6be0e0fec149fba82f00ae.wav";